import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { getFederationById } from '../../root-store/federations-store/selectors';
import { FederationsStoreSelectors } from '../../root-store/federations-store';
import * as RoutesDefinitions from '../../routes-definitions';
import { AccessLevel } from '../../shared-module/enums';
import { IFederationListItem } from '../models';

@Injectable({
	providedIn: 'root'
})
export class FederationAdminGuard implements CanActivate {
	private router = inject(Router)
	private store = inject(Store)

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
		const hasLoadedOnce$ = this.store.select(FederationsStoreSelectors.selectHasLoadedOnce);
		const subsidiaryById$ = this.store.select(FederationsStoreSelectors.selectFederations).pipe(map(feds => getFederationById(feds, +route.params.id)));

		return hasLoadedOnce$.pipe(
			filter(hasLoadedOnce => hasLoadedOnce),
			switchMap(_ => subsidiaryById$),
			map((fed: IFederationListItem) => !!fed && fed.accessLevel === AccessLevel.Admin),
			map(canAccess => {
				if (!canAccess) { this.router.navigate([RoutesDefinitions.getFederationsFullPath()]); }
				return canAccess;
			})
		);
	}
}
